import cleanNullInputs from '../infra/cleanNullInputs'
import qs from 'qs';

export default class Api {

    constructor(baseUrl, httpClient) {
        this.baseUrl = baseUrl
        httpClient.defaults.baseURL = baseUrl
        this.client = httpClient
    }

    async get (id, endpoint) {
        const response  = await this.client.get(`${endpoint}/${id}`);
        return response.data;
    }

    async store (data, endpoint) {
        try{
            return await this.client.post(endpoint, cleanNullInputs(data));
        }catch ({response}) {
            return response;
        }
    }

    async update (id, data, endpoint) {
        try{
            return await this.client.put(`${endpoint}/${id}`, cleanNullInputs(data));
        }catch ({response}) {
            return response;
        }
    }

    async index (parameters, endpoint) {
        const {data, status} = await this.client.get(endpoint, {
            params: parameters
        });

        if (status === 200) {
            return data;
        }
        throw new Error('Invalid response');
    }

    async research (parameters, endpoint) {
        const {data, status} = await this.client.get(endpoint, {
            params: parameters,
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        });

        if (status === 200) {
            return data;
        }
        throw new Error('Invalid response');
    }

    async fetch(endpoint) {
        const {data, status} = await this.client.get(endpoint);

        if (status === 200) {
            return data;
        }
        throw new Error('Invalid response');
    }

    async delete (id, endpoint) {
        try{
            return await this.client.delete(`${endpoint}/${id}`);
        }catch ({response}) {
            return response;
        }
    }

}
